import styled from 'styled-components';

// CONSTANTS
import colors from '@/constants/colors';

const { appCard } = colors;

export const AppCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px 25px 20px;
  border-radius: 6px;
  background-color: ${appCard.bg};
  transition: all 0.4s;
`;

export default AppCardContainer;
